export default __webpack_public_path__ + "static/media/totoro.1aea1c29.gif";